"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpRequestMonitor_1 = require("../../Http/HttpRequestMonitor");
var CONFIG_HTTP_MONITOR_1 = require("../Constants/CONFIG_HTTP_MONITOR");
function createHttpRequestMonitor(shaka, bandwidthEstimation) {
    var httpRequestMonitor = new HttpRequestMonitor_1.default(shaka, bandwidthEstimation);
    httpRequestMonitor.configure(CONFIG_HTTP_MONITOR_1.default);
    return httpRequestMonitor;
}
exports.default = createHttpRequestMonitor;
//# sourceMappingURL=createHttpRequestMonitor.js.map